<div class="basic-tooltip">
  <div class="tooltip-header" [style.display]="hasHeader() ? 'flex' : 'none'">
    <svg-icon
      src="assets/icons/explain-question-mark.svg"
      class="mobile-tooltip-sheet-icon"
    ></svg-icon>
    <ng-content select="[tooltipHeader]"></ng-content>
    @if (hasHeader()) {
      <svg-icon
        class="tooltip-close-icon"
        [src]="'assets/icons/cross.svg'"
        (click)="onCloseClick($event)"
      ></svg-icon>
      <div class="mobile-tooltip-sheet-dragger"></div>
    }
  </div>
  @if (hasHeader()) {
    <nz-divider></nz-divider>
  }
  <div class="tooltip-content">
    <ng-content select="[tooltipContent]"></ng-content>
  </div>
</div>
